import { Deal } from '@services/deals/types/deal';

export const getDealAvatar = (deal: Deal): string | undefined => {
  if (deal.artists?.length) {
    const avatar = deal.artists.find(a => !!a.avatarUrl)?.avatarUrl
    if (avatar) {
      return avatar;
    }
  }
  if (deal.labels?.length) {
    const avatar = deal.labels.find(a => !!a.avatarUrl)?.avatarUrl
    if (avatar) {
      return avatar;
    }
  }
  if (deal.isrcs?.length) {
    const avatar = deal.isrcs.find(a => !!a.coverArtUrl)?.coverArtUrl
    if (avatar) {
      return avatar;
    }
  }
}